<template>
    <div class="tc-select-case-workspace tc-thin-scrollbar"
         id="case-lib">
        <div class="tc-select-case-workspace-inner">
            <div class="tc-select-case-header">
                <div class="tc-select-case-description">
                    Добавление шкафа в Мой проект 1
                </div>
                <div class="tc-select-case-label">
                    Выберите шкаф
                </div>
            </div>

            <div class="tc-select-case-categories-grid">
                <SelectCaseCategoryCard v-for="item in caseCategories"
                                        :category-name="item.name"
                                        :category-description="item.description"
                                        :category-image="item.image"
                                        @click="scrollToEl(item.id)"/>

            </div>

            <SelectCaseCategory v-for="item in caseCategories"
                                :category-id="item.id"
                                :category-name="item.name"
                                :category-description="item.description"/>
        </div>
        <ScrollUp @click="scrollToTop"/>
    </div>
</template>

<script>
import SelectCaseCategoryCard from '@/UI/SelectCase/SelectCaseCategoryCard.vue';
import SelectCaseCategory from '@/UI/SelectCase/SelectCaseCategory.vue';
import ScrollUp from '@/UI/SelectCase/ScrollUp.vue';
import { caseCategories } from '@/Constants/caseCategories';

export default {
    name: 'TheSelectCase',
    components: {
        ScrollUp,
        SelectCaseCategory,
        SelectCaseCategoryCard,
    },
    data() {
        return {
            caseCategories: [ ...caseCategories ],
        };
    },
    methods: {
        scrollToEl(id) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                console.error('Element w/ id: ' + id + ' not found!');
            }
        },
        scrollToTop() {
            const element = document.getElementById('case-lib');
            if (element) {
                element.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                console.error('Element w/ id: case-lib not found!');
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/scrollbar";

.tc-select-case-workspace {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
    overflow: auto;
    position: absolute;
    z-index: 10;
    background-color: #f2f2f2;
    padding: 30px 0;
}

.tc-select-case-workspace-inner {
    width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow-y: hidden;
    overflow-x: hidden;
    margin: auto;
    height: max-content;
    min-height: 100%;
    gap: 30px;

    //background-color: #ffffff;
}

.tc-select-case-header {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: max-content;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-direction: column;
    color: #333333;
}

.tc-select-case-description {
    font-size: 14px;
}

.tc-select-case-label {
    font-size: 20px;
    font-weight: 600;
}

.tc-select-case-categories-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 15px;
    height: max-content;
    width: 100%;
    box-sizing: border-box;
}

</style>
